import { Component, OnInit, Inject, Injector } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BuildingService } from '../../building/building.service';
import { Building } from '../../building/building.interface';
import { Cluster } from '../cluster.interface';

@Component({
  selector: 'sg2-cluster-edit',
  templateUrl: './cluster-edit.component.html',
  styleUrls: ['./cluster-edit.component.less']
})
export class ClusterEditComponent implements OnInit {

  /** Parent building. */
  private building: Building;

  /** Building service reference from the injector. */
  private buildingService: BuildingService;

  /** Current cluster. */
  private cluster: Cluster;

  /** Form. */
  public form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly config: any,
    public dialogRef: MatDialogRef<ClusterEditComponent>,
    private formBuilder: FormBuilder,
    private injector: Injector
  ) {
    /** @todo Fix in 2711 */
    /* tslint:disable-next-line */
    this.buildingService = this.injector.get('BuildingService');
  }

  ngOnInit() {
    this.cluster = this.config.cluster;
    this.building = this.buildingService.getBuilding(this.cluster.buildingId);

    this._setForm();
  }

  /**
   * Submit and return updated cluster.
   */
  public submit(): void {
    this.dialogRef.close(this.form.value as Partial<Cluster>);
  }

  /**
   * Initialize form and set validators.
   */
  private _setForm(): void {
    this.form = this.formBuilder.group({
      name: [this.cluster.name, [
        Validators.required,
        this._uniqueNameValidator.bind(this)
      ]],
      shortCode: [this.cluster.shortCode, [
        Validators.required,
        Validators.maxLength(5),
        this._uniqueShortCodeValidator.bind(this)
      ]]
    });
  }

  /**
   * Check if the name is unique.
   *
   * @param control The current form control.
   */
  private _uniqueNameValidator(control: FormControl): void {
    const names = this.building.clusters
      .filter(c => c._id !== this.cluster._id)
      .filter(c => c.active)
      .map(c => c.name);
    if (control.valid) {
      if (names.indexOf(control.value) > -1) {
        setTimeout(() => {
          control.setErrors({ unique: true });
        });
      }
    }
  }

  /**
   * Check if the shortcode is unique.
   *
   * @param control The current form control.
   */
  private _uniqueShortCodeValidator(control: FormControl): void {
    const shortCodes = this.building.clusters
      .filter(c => c._id !== this.cluster._id)
      .filter(c => c.active)
      .map(c => c.shortCode);
    if (control.valid) {
      if (shortCodes.indexOf(control.value) > -1) {
        setTimeout(() => {
          control.setErrors({ unique: true });
        });
      }
    }
  }
}
